import {Component, Prop, Vue} from "vue-property-decorator";
import {Tab, Tabs} from "~/components/tabs";

export enum StatsTab {
  Auth,
  Actions,
}

@Component
export class StatsNavigationTabs extends Vue {

  @Prop({type: Number, required: true}) value: StatsTab;

  render() {
    return (
      <Tabs>
        <Tab isActive={this.value === StatsTab.Auth}
             onClick={() => this.$emit("input", StatsTab.Auth)}>
          Connexions
        </Tab>
        <Tab isActive={this.value === StatsTab.Actions}
             onClick={() => this.$emit("input", StatsTab.Actions)}>
          Actions
        </Tab>
      </Tabs>
    );
  }

}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-e2e6cc2a/navigation-tabs.tsx" });